import { API } from '../../../constants/api.constants';
import { apiClient, apiEndpoint } from '../../../services/api.services';

export const getCompanyUsers = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.USER_MANAGEMENT.GET_COMPANY_USERS}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getMyTodoFilterMasters = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.MY_TODO_FILTER_MASTERS}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};